<template>
  <div>
    <v-dialog v-model="dialog" persistent fullscreen>
      <edit-timecard
        @closeDialog="closeDialog"
        @saveItem="saveItem"
        @deleteItem="deleteItem"
        v-model="selectedTimecard"
        :owner="owner"
        v-if="dialog"
      />
    </v-dialog>
    <v-container grid-list-md text-md-center>
      <v-layout class="non-printable" row>
        <v-flex md5>
          <holiday-table />
        </v-flex>
        <v-flex md7>
          <v-layout row style="text-align: end">
            <v-flex md12 align-self-end>
              <v-btn
                color="blue"
                class="white--text"
                @click="startWork('出社')"
                :disabled="hasTodaysTimecard || readOnly"
                >出社出勤</v-btn
              >

              <v-btn
                color="green"
                class="white--text"
                @click="startWork('在宅')"
                :disabled="hasTodaysTimecard || readOnly"
                >在宅出勤</v-btn
              >

              <v-btn
                color="deep-orange"
                class="white--text"
                @click="endWork()"
                :disabled="readOnly"
                >退勤</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout row style="text-align: end" v-if="CanI('ImportTimecards')">
            <v-flex md12>
              <input type="file" @change="selectedFile" />
              <v-btn :disabled="file == null" @click="importFile"
                >インポート</v-btn
              >
              <a @click="downloadFile">インポート用ファイルダウンロード</a>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout id="time-table-wrapper">
      <div class="table-container scroll-bar">
        <v-data-table
          :headers="headers"
          :items="timesheetItems"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:headers="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="
                  header.non_printable
                    ? ['non-printable', 'sticky']
                    : ['sticky']
                "
              >
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template slot="items" slot-scope="props">
            <tr @click="editItem(props.item)">
              <td
                v-if="
                  !props.item.timecard ||
                  !('is_completed' in props.item.timecard)
                "
              ></td>
              <td v-else-if="props.item.timecard.is_completed">
                <v-icon>done</v-icon>
              </td>
              <td v-else></td>
              <td class="text-xs-left" :class="dayClass(props.item)">
                {{ props.item.date }}
              </td>
              <td class="text-xs-left" :class="dayClass(props.item)">
                {{ props.item.day }}
              </td>
              <td class="text-xs-left text-smaller">
                {{ props.item.timecard ? props.item.timecard.holidayType : "" }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.timecard && props.item.timecard.start > 0
                    ? getTime(props.item.timecard.start)
                    : ""
                }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.timecard && endtimeIsValid(props.item.timecard)
                    ? getTime(props.item.timecard.end)
                    : ""
                }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.timecard && endtimeIsValid(props.item.timecard)
                    ? getNonworking(props.item.timecard)
                    : ""
                }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.timecard && endtimeIsValid(props.item.timecard)
                    ? getWorking(props.item.timecard)
                    : ""
                }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.timecard && endtimeIsValid(props.item.timecard)
                    ? getLateNight(props.item.timecard)
                    : ""
                }}
              </td>
              <td class="text-xs-left">
                {{
                  props.item.timecard &&
                  props.item.timecard.is_completed &&
                  props.item.timecard.actual_home_working_hours
                    ? getTime(props.item.timecard.actual_home_working_hours)
                    : ""
                }}
              </td>
              <td
                class="text-xs-left text-smaller"
                v-if="owner.work_type == '時給'"
              >
                {{
                  props.item.timecard && endtimeIsValid(props.item.timecard)
                    ? getTime(props.item.timecard.overtime)
                    : ""
                }}
              </td>

              <td class="text-xs-left text-smaller non-printable">
                {{ props.item.timecard ? isEdited(props.item.timecard) : "" }}
              </td>
              <td class="text-xs-left text-smaller non-printable">
                <summary-data-tooltip
                  :items="props.item.timecard.costs"
                  v-if="
                    props.item.timecard && endtimeIsValid(props.item.timecard)
                  "
                />
              </td>
              <td class="text-xs-left text-smaller non-printable">
                <summary-data-tooltip
                  v-if="props.item.timecard && props.item.timecard.is_completed"
                  :items="props.item.timecard.expenses"
                />
              </td>
              <td class="text-xs-left text-smaller">
                <v-tooltip
                  top
                  v-if="props.item.timecard && props.item.timecard.note"
                >
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{
                      getSummaryOfNote(props.item.timecard.note)
                    }}</span>
                  </template>
                  <span>{{ props.item.timecard.note }}</span>
                </v-tooltip>
              </td>
              <td
                class="text-xs-left text-smaller"
                v-if="
                  owner.commuting_allowance_type &&
                  owner.commuting_allowance_type == '日額'
                "
              >
                {{
                  props.item.timecard &&
                  props.item.timecard.daily_commuting_allowance
                    ? toFormattedMoney(
                        props.item.timecard.daily_commuting_allowance
                      )
                    : ""
                }}
              </td>
            </tr>
          </template>
          <template slot="no-data">
            <v-btn color="primary">Reset</v-btn>
          </template>
        </v-data-table>
      </div>
    </v-layout>
    <v-btn color="green" class="white--text non-printable" @click="scrollToTop">
      <v-icon color="white">arrow_upward</v-icon>トップへ戻る
    </v-btn>
  </div>
</template>

<script>
import db from "@/components/firebaseInit";
import XLSX from "xlsx";
import EditTimecard from "@/components/editTimecard";
import HolidayTable from "@/components/Home/holidayTable";
import PaidDaysOffTable from "@/components/Home/paidDaysOffTable";
import SummaryDataTooltip from "@/components/Home/summaryDataAndTooltip";
import { unixtimeToFormattedTime, getMoment } from "@/utils/datetime.js";
import { mapGetters, mapState, mapActions } from "vuex";
import {
  startWork,
  endWork,
  timecardNew,
  saveTimecard,
  updateTimecard,
} from "@/utils/startAndEndWork.js";

var moment = require("moment-timezone");
moment.tz.setDefault("Asia/Tokyo");
const keysOfOwnerToCopyToTimecard = {
  owner_id: "id",
  owner_name: "name",
  owner_team: "team_name",
  owner_user_type: "user_type",
  owner_work_type: "work_type",
};
export default {
  components: {
    EditTimecard,
    HolidayTable,
    SummaryDataTooltip,
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    dbRef: db.collection("timecards"),
    items: {},
    action: "update",
    headers: [],
    dialog: false,
    pagination: {},
    timecards: {},
    selectedTimecard: {},
    sumTravelExpenses: 0,
    sumOtherExpenses: 0,
    hasTodaysTimecard: false,
    file: null,
    day_types: [
      "有休",
      "半休",
      "無給",
      "欠勤",
      "半欠勤",
      "振休",
      "振休(所定休)",
      "振出",
      "所定休",
      "特別有休（M休やV休）",
      "産前休",
      "産後休",
      "育児休",
      "介護休",
      "休職",
      "その他休"
    ],
  }),
  computed: {
    ...mapGetters("auth", ["CanI", "isLoggedIn", "user"]),
    ...mapGetters("timesheet", [
      "timesheetItems",
      "owner",
      "monthId",
      "moneyCounts",
    ]),
  },
  mounted() {
    if (this.owner.work_type == "時給") {
      this.headers = [
        { sortable: false, width: "2%" }, //何故か1日のみテンプレートIDがクラスに入らないので特殊対応
        { text: "日", value: "date", sortable: false, width: "3%" },
        { text: "曜日", value: "day", sortable: false, width: "3%" },
        { text: "休暇", sortable: false, width: "5%" },
        { text: "始業", sortable: false, width: "5%" },
        { text: "終業", sortable: false, width: "5%" },
        { text: "差引", sortable: false, width: "5%" },
        { text: "実働", sortable: false, width: "5%" },
        { text: "深夜", sortable: false, width: "5%" },
        { text: "在宅", sortable: false, width: "5%"},
        { text: "超過", sortable: false, width: "5%" },
        { text: "修正", sortable: false, width: "5%", non_printable: true },
        {
          text: "原価概要",
          sortable: false,
          width: "30%",
          non_printable: true,
        },
        { text: "経費概要", sortable: false, width: "5%", non_printable: true },
        { text: "備考", sortable: false, width: "20%"},
      ];
    } else {
      this.headers = [
        { sortable: false, width: "2%" }, //何故か1日のみテンプレートIDがクラスに入らないので特殊対応
        { text: "日", value: "date", sortable: false, width: "3%" },
        { text: "曜日", value: "day", sortable: false, width: "3%" },
        { text: "休暇", sortable: false, width: "5%" },
        { text: "始業", sortable: false, width: "5%" },
        { text: "終業", sortable: false, width: "5%" },
        { text: "差引", sortable: false, width: "5%" },
        { text: "実働", sortable: false, width: "5%" },
        { text: "深夜", sortable: false, width: "5%" },
        { text: "在宅", sortable: false, width: "5%" },
        { text: "修正", sortable: false, width: "5%", non_printable: true },
        {
          text: "原価概要",
          sortable: false,
          width: "32%",
          non_printable: true,
        },
        { text: "経費概要", sortable: false, width: "5%", non_printable: true },
        { text: "備考", sortable: false, width: "20%" },
      ];
    }

    if (this.owner.commuting_allowance_type == "日額") {
      this.headers.push({ text: "交通費", sortable: false, width: "7%" });
    }
    this.fixHeaders();
  },
  methods: {
    scrollToTop() {
      document.querySelector(".v-datatable tbody tr").scrollIntoView(false);
    },
    async reloadItems() {
      this.changeLoadingState(true);
      this.items = await this.getTimesheet({
        monthId: this.monthId,
        ownerId: this.$route.params.user_id,
      });
      this.changeLoadingState(false);
    },
    async startWork(workType) {
      const calendarItem = this.getTodayTimesheetItem();
      const response = await startWork(this.owner, calendarItem, workType);

      if (response.status == "ok") {
        this.reloadItems();
      } else {
        window.alert("出勤処理に失敗しました。もう一度実施してください。");
      }
    },
    async endWork() {
      const calendarItem = this.getTodayTimesheetItem();
      const response = await endWork(this.owner, calendarItem);
      if (response.status == "ok") {
        this.selectedTimecard = { ...response.data };
        this.dialog = true;
      } else {
        window.alert("退勤処理に失敗しました。もう一度実施してください。");
      }
    },
    getWorking(timecard) {
      return this.getTime(
        timecard.end -
          timecard.start -
          timecard.lunch -
          timecard.break -
          (timecard.total_nonworking_hours
            ? timecard.total_nonworking_hours
            : 0)
      );
    },
    getNonworking(timecard) {
      return this.getTime(
        timecard.lunch +
          timecard.break +
          (timecard.total_nonworking_hours
            ? timecard.total_nonworking_hours
            : 0)
      );
    },
    getLateNight(timecard) {
      const lateNightTime = 22 * 3600;
      var tmp =
        timecard.end - lateNightTime <= 0 ? 0 : timecard.end - lateNightTime;
      return this.getTime(
        timecard.end - lateNightTime <= 0 ? 0 : timecard.end - lateNightTime
      );
    },
    isEdited(timecard) {
      return timecard.isEditWorktime && timecard.isEditWorktime ? "修正" : "";
    },
    itemHastimecard(timesheetItem) {
      return (
        timesheetItem.timecard && Object.keys(timesheetItem.timecard).length
      );
    },
    getTodayTimesheetItem() {
      const now = moment();
      const today = now.hours() <= 4 ? now.date() - 1 : now.date();
      const dateId = this.getDateId(now.year(), now.month() + 1, today);
      return this.timesheetItems.find((item) => item.id == dateId);
    },
    getDateId(year, month, date) {
      return (
        String(year) +
        "-" +
        ("0" + month).slice(-2) +
        "-" +
        ("0" + date).slice(-2)
      );
    },
    endtimeIsValid(tc) {
      return tc.end - tc.start - tc.lunch - tc.break > 0;
    },
    getTime(unixtime) {
      if (unixtime == 0) {
        return "00:00";
      } else {
        return unixtime
          ? ("0" + Math.floor(unixtime / 3600)).slice(-2) +
              ":" +
              ("0" + Math.floor((unixtime % 3600) / 60)).slice(-2)
          : "";
      }
    },
    editItem(timesheetItem) {
      if (this.readOnly) return;
      if (!this.itemHastimecard(timesheetItem)) {
        this.selectedTimecard = timecardNew(this.owner, timesheetItem);
        this.action = "create";
      } else {
        this.selectedTimecard = JSON.parse(
          JSON.stringify(timesheetItem.timecard)
        );
        this.action = "update";
      }
      this.dialog = true;
    },
    async saveItem() {
      const res = await saveTimecard(this.selectedTimecard, this.owner);
      if (res) {
        this.closeDialog();
        this.reloadItems();
      } else {
        window.alert("保存に失敗しました。もう一度実施してください。");
      }
    },
    toFormattedMoney(m) {
      const money = Number(m);
      return Number.isInteger(money)
        ? "¥ " + money.toLocaleString("ja")
        : "Invalid Money :" + money;
    },
    async deleteItem() {
      try {
        await this.dbRef.doc(this.selectedTimecard.id).delete();
        this.reloadItems();
        this.closeDialog();
      } catch (e) {
        console.error(e);
      }
    },
    dateFormat(unixtime) {
      return moment.unix(unixtime).format("MM/DD");
    },
    closeDialog() {
      this.dialog = false;
    },
    dayClass(d) {
      if (d.day_number == 0 || d.is_holiday) {
        return { holiday: true };
      } else if (d.day_number == 6) {
        return { saturday: true };
      }
    },
    getSummaryOfCost(costs) {
      let summary = "";
      costs.forEach((cost) => {
        if (cost.time > 0) {
          summary =
            summary +
            cost.client_name.replace("株式会社", "").replace("有限会社", "") +
            ":" +
            unixtimeToFormattedTime(cost.time) +
            ", ";
        }
      });
      summary = summary.slice(0, -2); //最後の", "を削除
      return summary.length >= 30 ? summary.slice(0, 29) + "..." : summary;
    },
    getSummaryOfExpence(expenses) {
      let summary = "";
      expenses.forEach((expense) => {
        summary =
          summary +
          expense.client_id +
          expense.client_name.replace("株式会社", "").replace("有限会社", "") +
          ": ¥" +
          expense.price +
          ", ";
      });
      summary = summary.slice(0, -2); //最後の", "を削除
      return summary.length >= 30 ? summary.slice(0, 29) + "..." : summary;
    },
    getSummaryOfNote(note) {
      return note && note.length >= 30 ? note.slice(0, 29) + "..." : note;
    },
    fixHeaders() {
      var elms = document.getElementsByClassName("v-table__overflow");
      console.log(elms);
      elms[0].style.overflow = "visible";
    },
    selectedFile(e) {
      e.preventDefault();
      this.file = e.target.files[0];
    },
    importFile() {
      const reader = new FileReader();
      reader.readAsArrayBuffer(this.file);
      reader.onload = (e) => {
        const data = new Uint8Array(reader.result);
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const items = XLSX.utils.sheet_to_json(worksheet);
        const promises = [];
        items.filter(item => item.update).forEach((item) => {
          const timecard = item.timecard ? {date_id:item.id} : timecardNew(this.owner, item);
          if(Number.isInteger(item.daily_commuting_allowance)){
            timecard.daily_commuting_allowance = item.daily_commuting_allowance;
          }
          if(item.holidayType && this.day_types.includes(item.holidayType)){
            timecard.holidayType = item.holidayType;
          }
          if(!item.timecard){
            timecard.is_completed = true;
          }
          console.log(timecard)
          const p = updateTimecard(timecard, this.owner);
          promises.push(p);
        });
        Promise.all(promises).then(() => {
          this.reloadItems();
        });
      };
    },
    downloadFile() {
      const headers = [
        "update",
        "id",
        "day",
        "year",
        "month",
        "date",
        "is_holiday",
        "holiday_name",
        "day_number",
        "timecard",
      ];
      var FileSaver = require("file-saver");
      var workbook = { SheetNames: [], Sheets: {} };
      var wopts = { bookType: "xlsx", bookSST: false, type: "array" };

      const tableData = [];
      const timecard_headers = ["holidayType", "daily_commuting_allowance"];
      tableData.push(headers.concat(timecard_headers));

      this.timesheetItems.forEach((item) => {
        const row = headers.map((header) => {
          if (header == "timecard") {
            return item[header] ? true : false;
          }else if(header == "update"){
            return false;
          }
          return item[header];
        });
        if (item.timecard) {
          const timecard_row = timecard_headers.map((header) => {
            return item.timecard[header];
          });
          row.push(...timecard_row);
        } else {
          row.push(...Array(timecard_headers.length).fill(""));
        }
        tableData.push(row);
      });

      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet(tableData),
        "import_template"
      );
      XLSX.utils.book_append_sheet(
        workbook,
        XLSX.utils.aoa_to_sheet([
          ["休暇は下記のどれかを追記してください。"],
          this.day_types
        ]),
        "notes"
      );

      var wbout = XLSX.write(workbook, wopts);
      var blob = new Blob([wbout], { type: "application/octet-stream" });
      FileSaver.saveAs(blob, "import_template.xlsx");
    },
    ...mapActions("app", ["changeLoadingState"]),
    ...mapActions("timesheet", ["getTimesheet", "saveTimesheet"]),
  },
};
</script>
<style lang="css" scoped>
td.holiday {
  color: #f44336;
}
td.saturday {
  color: #2196f3;
}
td.text-smaller {
  font-size: 0.8em;
}
.v-datatable th.sticky {
  background-color: white !important;
  position: -webkit-sticky;
  position: sticky;
  z-index: 1;
  top: 0;
}
.scroll-bar {
  overflow: auto;
}
.scroll-bar::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.scroll-bar::-webkit-scrollbar-thumb {
  background: gray;
}
.v-icon {
  margin-right: 0.3em;
}
#time-table-wrapper {
  height: 400px;
  width: 100%;
}
@media print {
  .scroll-bar {
    overflow: visible;
  }
  .non-printable {
    display: none;
  }
  #time-table-wrapper {
    height: 100%;
    width: 100%;
  }
}
</style>